/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from 'yup';
import checkout from 'pages/new-account/schemas/form';

const {
  formField: {
    email,
    password,
    repeatPassword,
    subscriptionDuration,
    playlist,
  },
} = checkout;

const validations = Yup.object().shape({
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [password.name]: Yup.string()
    .required(password.errorMsg)
    .min(6, password.invalidMsg),
  [password.name]: Yup.string()
    // .required(password.errorMsg)
    .min(6, password.invalidMsg),
  [repeatPassword.name]: Yup.string()
    // .required(repeatPassword.errorMsg)
    .oneOf([Yup.ref('password'), null], repeatPassword.invalidMsg),
  [subscriptionDuration.name]: Yup.string()
    .required(subscriptionDuration.errorMsg)
    .oneOf(['1', '3', '12'], subscriptionDuration.invalidMsg),
  //improve maybe?
  [playlist.name]: Yup.string().matches(/^https?:\/\//g, playlist.invalidMsg),
});

export default validations;
